module.exports = __webpack_public_path__ + "img/pattern1.f20b69d4.png";